import { useAppDispatch, useAppSelector } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import Details from './components/Details';
import Config from './components/Config';
import { addTemplate } from '../../features/admin/templates/slice';
import { Template } from '@/types';
import routes from '@/constants/routes';

export type FormValues = Partial<Template>;

const NewTemplate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector(state => state.auth.user);

  interface DispatchResponse {
    payload: {
      id: string,
    },
    meta: {
      requestStatus: 'fulfilled' | 'rejected';
    }
  }

  const handleSubmit = async (values: FormValues) => {
    const response = await dispatch(addTemplate(values)) as DispatchResponse;
    if (response.meta.requestStatus === 'fulfilled') {
      navigate(
        routes.templates.edit
          .replace(':templateId', response.payload.id)
          .replace(':organizationId', 'ACME')
      );
    }
  };

  return (
    <Container sx={{ width: '100%', marginTop: 4 }}>
      <Paper sx={{ padding: 4 }}>
        <Typography variant="h1" sx={{ marginBottom: 3 }}>
          Crear Plantilla
        </Typography>
        <Formik
          initialValues={{
            isPrivate: false,
            isPublished: false,
            createdBy: user?.uid ?? '',
            type: 'web',
          }}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit }) => (
            <Form>
              <Box>
                <Details/>
                <Config/>
              </Box>
              <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center">
                <Button
                  variant="outlined"
                  onClick={() => navigate(routes.templates.main)}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={handleSubmit}
                >
                  Guardar
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Paper>
    </Container>
  );
};

export default NewTemplate;
